import noop from 'lodash/noop';
import { createContext } from 'react';

import type { ParentHelperContext } from './types';

export const context = createContext<ParentHelperContext>({
  data: [],
  isLoadingAnswer: false,
  isLoadingChat: false,
  isError: false,
  chatId: null,
  sendQuestion: noop,
  isLoadingChatTopics: false,
  setChatId: noop,
  chatTopics: [],
  setChatTopics: noop,
  isLoadingMore: false,
  loadMore: noop,
  chatTopicsData: undefined,
  shouldScrollToBottom: false,
  likeMessage: () => Promise.resolve(),
  dislikeMessage: () => Promise.resolve(),
  deleteChat: noop,
  setDeletedChatId: noop,
  deletedChatId: null,
});

export const { Provider } = context;
